import React, { Component } from 'react';
import { HTTPService } from '../services/httpService'; // Adjust path as needed

const API = new HTTPService();

export default class NotesForm extends Component {
    state = {
        notes: "",
        dealerContact: this.props.dealerContact || "", // Empty until a contact is explicitly selected
        dealerContacts: [], // Will hold users and contacts
        loadingContacts: false,
        showAddContact: false,
        newContact: {
            name: "",
            email: "",
            phone: "",
            role: "contact"
        },
        addingContact: false,
        dealNumber: ""
    };

    async componentDidMount() {
        // Load dealer contacts when component mounts on step 4
        if (this.props.currentStep === 4 && this.props.requestType === "dealer") {
            await this.loadDealerContacts();
        }
    }

    async componentDidUpdate(prevProps) {
        // Load contacts when we reach step 4 (for timing with dealership selection)
        if (this.props.currentStep === 4 && prevProps.currentStep !== 4 && this.props.requestType === "dealer") {
            await this.loadDealerContacts();
        }
        
        // Reload if dealership selection changes (for installer-created dealer jobs)
        if (this.props.selectedDealership !== prevProps.selectedDealership && this.props.selectedDealership) {
            await this.loadDealerContacts();
        }
    }

    loadDealerContacts = async () => {
        this.setState({ loadingContacts: true });
        try {
            // Get the correct dealer ID based on who's creating the job
            let dealerId;
            if (this.props.userType === "dealer") {
                // Dealer creating job - use their ID
                dealerId = this.props.dealerId || this.props.typeId;
            } else {
                // Installer creating dealer job - use selected dealership
                dealerId = this.props.selectedDealership;
            }
  console.log('Loading contacts for dealerId:', dealerId, this.props.userType);

            if (!dealerId) return; // No dealership selected yet

            // Use the correct endpoint: /dealerContacts/:dealerId
  const { data: contacts } = await API.get(`/dealerContacts/${dealerId}`);
  console.log('Contacts returned:', contacts);            this.setState({ dealerContacts: contacts || [] });
        } catch (error) {
            console.error("Error loading dealer contacts:", error);
            this.setState({ dealerContacts: [] });
        } finally {
            this.setState({ loadingContacts: false });
        }
    };

    handleChange = ({currentTarget : input}) => {
        //console.log(input);
        this.setState( {notes : input.value});
    };

    handleContactChange = ({currentTarget : input}) => {
        if (input.value === "add_new") {
            this.setState({ showAddContact: true });
        } else {
            this.setState({ dealerContact: input.value });
            // Pass the contact selection back to parent
            if (this.props.handleContactChange) {
                this.props.handleContactChange(input.value);
            }
        }
    };
handleDealNumberChange = ({currentTarget : input}) => {
    this.setState({ dealNumber: input.value });
    // Pass to parent
    if (this.props.onDealNumberChange) {
        this.props.onDealNumberChange(input.value);
    }
};
    handleNewContactChange = ({currentTarget : input}) => {
        const { name, value, type, checked } = input;
        this.setState({
            newContact: {
                ...this.state.newContact,
                [name]: type === 'checkbox' ? checked : value
            }
        });
    };

    handleAddNewContact = async () => {
        const { newContact } = this.state;

        // Basic validation
        if (!newContact.name || !newContact.email) {
            alert("Name and email are required");
            return;
        }

        this.setState({ addingContact: true });

        try {
            // Get the correct dealer ID
            let dealerId;
            if (this.props.userType === "dealer") {
                dealerId = this.props.dealerId || this.props.typeId;
            } else {
                dealerId = this.props.selectedDealership;
            }

            // Add the new contact via POST /users (contact-only, no Cognito account)
            const contactData = {
                email: newContact.email.trim().toLowerCase(),
                userName: newContact.name.trim(),
                userPhoneNumber: newContact.phone ? newContact.phone.replace(/\D/g, '') : '',
                companyId: dealerId,
                userType: 'dealer',
                userRole: newContact.role || 'contact',
                access: 'NONE',  // Contact only - no system access
                active: 1
            };

            const { data: result } = await API.post('/users', contactData);

            // Create a user object matching the format from dealerContacts endpoint
            const newContactUser = {
                User_id: result.userId,
                user_name: newContact.name.trim(),
                Email: newContact.email.trim().toLowerCase(),
                user_phone_number: newContact.phone || '',
                role: newContact.role || 'contact',
                active: 1
            };

            // Add to local list and select it
            const updatedContacts = [...this.state.dealerContacts, newContactUser];
            this.setState({
                dealerContacts: updatedContacts,
                dealerContact: result.userId,
                showAddContact: false,
                newContact: { name: "", email: "", phone: "", role: "contact" }
            });

            // Pass the new contact selection back to parent
            if (this.props.handleContactChange) {
                this.props.handleContactChange(result.userId);
            }
            if (this.props.onDealNumberChange) {
                this.props.onDealNumberChange(this.state.dealNumber);
            }
        } catch (error) {
            console.error("Error adding contact:", error);
            if (error.response?.status === 409) {
                alert("A user with this email already exists.");
            } else {
                alert("Failed to add contact. Please try again.");
            }
        } finally {
            this.setState({ addingContact: false });
        }
    };

    handleCancelAddContact = () => {
        this.setState({
            showAddContact: false,
            newContact: { name: "", email: "", phone: "", role: "contact" }
        });
    };

    handleAdd = () => {
        this.props.handleNotes(this.state.notes);
        // Also pass the selected contact if this is a dealer job
        if (this.props.requestType === "dealer" && this.props.handleContactChange) {
            this.props.handleContactChange(this.state.dealerContact);
        }
    };

    render() { 
        let displayServices = "";
        for (var x=0; x < this.props.services.length; x++){
            if (x > 0){
                if (x === this.props.services.length - 1)
                    displayServices = displayServices + " & ";
                else
                    displayServices = displayServices + ", ";
            };
            displayServices = displayServices + this.props.services[x].Service_Category + " " + this.props.services[x].Description
        }
  
        if ((this.props.currentStep !== 4 && this.props.userType === "dealer") || 
        (this.props.currentStep !== 4 && this.props.userType === "installer")){
            return null
        };

        return (
            <React.Fragment>
                <h5 className="text-center bold mb-4">
                    Add any specific notes about the work & any additional features on vehicle that can impact price
                </h5>
                <form className="form-container p-5">
                        {this.props.requestType === "dealer" && (
        <div className="form-row justify-content-center">
            <div className="form-group col-6">
                <input 
                    type="text"
                    className="form-control"
                    name="dealNumber"
                    placeholder="Deal # (Optional)"
                    value={this.state.dealNumber}
                    onChange={this.handleDealNumberChange}
                    maxLength={50}
                />
            </div>
        </div>
    )}
                    <div className="form-row justify-content-center">
                        <textarea 
                            className="col-6" 
                            rows="6" 
                            columns="100" 
                            autoFocus 
                            name='notes' 
                            placeholder="Any special instructions or details about this work..."
                            value={this.state.notes} 
                            onChange={this.handleChange}
                        />
                    </div>

                    {/* Dealer Contact Selection - Only show for dealer jobs */}
                    {this.props.requestType === "dealer" && (
                        <div className="form-row justify-content-center mt-4">
                            <div className="form-group col-6">
                                <label htmlFor="dealerContact" className="font-weight-bold">
                                    Who should be notified about this request?
                                </label>
                                
                                {!this.state.showAddContact ? (
                                    <>
                                        <select 
                                            id="dealerContact"
                                            className="form-control"
                                            value={this.state.dealerContact}
                                            onChange={this.handleContactChange}
                                            disabled={this.state.loadingContacts}
                                        >
                                            <option value="">Select a contact (optional)</option>
                                            {this.state.dealerContacts.map(contact => (
                                                <option key={contact.User_id} value={contact.User_id}>
                                                    {contact.user_name} 
                                                    {contact.contact_role && ` (${contact.contact_role})`}
                                                    {contact.login_enabled === 0 && ' - Contact Only'}
                                                </option>
                                            ))}
                                            <option value="add_new">Add New Contact</option>
                                        </select>
                                        <small className="form-text text-muted">
                                            This person will receive updates about the work progress
                                        </small>
                                    </>
                                ) : (
                                    <div className="border p-3 bg-light">
                                        <h6>Add New Contact</h6>
                                        <div className="form-row">
                                            <div className="form-group col-6">
                                                <label>Name *</label>
                                                <input 
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name="name"
                                                    value={this.state.newContact.name}
                                                    onChange={this.handleNewContactChange}
                                                    placeholder="John Smith"
                                                />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Email *</label>
                                                <input 
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    name="email"
                                                    value={this.state.newContact.email}
                                                    onChange={this.handleNewContactChange}
                                                    placeholder="john@dealer.com"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-6">
                                                <label>Phone</label>
                                                <input 
                                                    type="tel"
                                                    className="form-control form-control-sm"
                                                    name="phone"
                                                    value={this.state.newContact.phone}
                                                    onChange={this.handleNewContactChange}
                                                    placeholder="(555) 123-4567"
                                                />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Role</label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    name="role"
                                                    value={this.state.newContact.role}
                                                    onChange={this.handleNewContactChange}
                                                >
                                                    <option value="sales">Sales</option>
                                                    <option value="finance">Finance</option>
                                                    <option value="manager">Manager</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <button 
                                                type="button"
                                                className="btn btn-success btn-sm mr-2"
                                                onClick={this.handleAddNewContact}
                                                disabled={this.state.addingContact || !this.state.newContact.name || !this.state.newContact.email}
                                            >
                                                {this.state.addingContact ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm mr-1"></span>
                                                        Adding...
                                                    </>
                                                ) : (
                                                    'Add Contact'
                                                )}
                                            </button>
                                            <button 
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                onClick={this.handleCancelAddContact}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                )}
                                
                                {this.state.loadingContacts && (
                                    <small className="form-text text-info">Loading team members...</small>
                                )}
                            </div>
                        </div>
                    )}
                    
                    <div className="form-row justify-content-md-center mt-3">
                        <div className="form-group col-md-2">
                            <button 
                                type="button" 
                                className="btn btn-block btn-success" 
                                onClick={this.handleAdd} 
                                disabled={this.state.notes === ""}
                            >
                                Save {this.props.requestType === "dealer" ? 'Notes & Contact' : 'Notes'}
                            </button>
                        </div>
                    </div>
                </form>

                {this.props.notes && (
                    <div>
                        <h5 className="text-center bold p-5">Work Notes</h5>
                        <div className="col-lg-12 bold text-center">
                            <p>{this.props.notes}</p>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}